import Vue from "vue";
import VueRouter from "vue-router";
import StartView from "../views/StartView.vue";
import SummaryView from "../views/SummaryView.vue";
import CalculateView from "../views/CalculateView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "StartView",
    component: StartView
  },
  {
    path: "/calculate",
    name: "CalculateView",
    props: true,
    component: CalculateView
  },
  {
    path: "/summary",
    name: "SummaryView",
    props: true,
    component: SummaryView
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;
